import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import CalculateIcon from '@mui/icons-material/Calculate';
import QuizIcon from '@mui/icons-material/Quiz';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

export interface StudentNavItem {
  label: string;
  to: string;
  icon: React.ReactNode;
}

interface StudentNavItemsOptions {
  teamsEnabled: boolean;
}

/**
 * The desktop top-level student nav, and the base the mobile drawer builds
 * from. Was the single source for both surfaces verbatim; no longer quite
 * true — see Hint Videos below — but this remains the one place their
 * shared order and icons are declared, so the two cannot drift on anything
 * else.
 *
 * Two items are deliberately absent:
 * - Messages renders differently per surface (an IconButton with a Badge on
 *   desktop, a ListItem with a badged icon on mobile), so it stays
 *   hand-written in Header.tsx rather than being modelled as a special case
 *   here.
 * - Hint Videos moved to the account menu on desktop only: eight buttons
 *   plus the messages icon visibly wrapped at the `md` breakpoint, and Hint
 *   Videos was the least-used destination of the eight. It stays in the
 *   mobile drawer (a vertical list has no width pressure), hand-added in
 *   Header.tsx at its original position, the same treatment as Messages.
 */
export function getStudentNavItems({ teamsEnabled }: StudentNavItemsOptions): StudentNavItem[] {
  const items: StudentNavItem[] = [
    { label: 'Dashboard', to: '/dashboard', icon: React.createElement(DashboardIcon) },
    { label: 'Sessions', to: '/sessions', icon: React.createElement(SchoolIcon) },
    { label: 'Problems', to: '/problems', icon: React.createElement(CalculateIcon) },
    { label: 'Quizzes', to: '/student/quizzes', icon: React.createElement(QuizIcon) },
    { label: 'Ranked', to: '/student/ranked', icon: React.createElement(MilitaryTechIcon) }
  ];

  if (teamsEnabled) {
    items.push({ label: 'Teams', to: '/student/teams', icon: React.createElement(GroupsIcon) });
  }

  items.push({ label: 'Leaderboard', to: '/leaderboard', icon: React.createElement(EmojiEventsIcon) });

  return items;
}
